import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';

export function MedicalNecessityCheckFormFields() {
  return (
    <>
      <BlockValueTemplateField
        fieldName="config.insuranceProvider"
        label="Insurance Provider"
        helperText="Check documentation for valid insurance providers"
        required
      />
      <BlockValueTemplateField
        fieldName="config.diagnoses"
        label="Diagnosis ICD-10 Codes"
        helperText='Provide codes as JSON array, example: ["U071", "C43.4"]'
        required
      />
      <BlockValueTemplateField
        fieldName="config.procedureCptCodes"
        label="Procedure CPT Codes"
        helperText='Provide CPT codes as JSON array, example: ["76536", "76524"]'
        required
      />
      <BlockValueTemplateField
        fieldName="config.procedureServiceDate"
        label="Procedure Service Date"
        helperText="Provide date in YYYY-MM-DD format, example: 2024-11-02"
      />
    </>
  );
}
